import ar from 'date-fns/locale/ar';
import { ReactElement } from 'react';
import * as React from 'react';
import { registerLocale } from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.min.css';

import DatePickerWithDays from '@/shared/components/molecules/CustomDatePicker/DatePickerWithDays';
import OnlyDatePicker from '@/shared/components/molecules/CustomDatePicker/OnlyDatePicker';
registerLocale('ar', ar);

interface ICustomDatePickerProps {
  defaultDate?: Date;
  onlyDatePicker?: boolean;
  onChange: (date: Date) => void;
}
/**
 *
 * @defaultDate  {Date} : default selected day if not passed that will be current day
 * @onlyDatePicker  : {boolean} : if true will render date picker only if false will render date picker with days
 * @onChange   : {fun(Date)} : when change selected day will call this fun with the new selected day
 * @returns
 */
export default function CustomDatePicker({
  defaultDate = new Date(),
  onChange,
  onlyDatePicker,
}: ICustomDatePickerProps): ReactElement {
  /* ****************************************onlyDatePicker******************************************* */
  // return date picker without days
  if (onlyDatePicker) {
    return <OnlyDatePicker onChange={onChange} defaultDate={defaultDate} />;
  }
  /* **************************************** datepicker with days *********************************** */

  return <DatePickerWithDays onChange={onChange} defaultDate={defaultDate} />;
}
